import { injectReducer } from '../../store/reducers'
import { getPatientDetail } from './modules/test'

export default (store) => ({
  path :  '/patient/:id/test',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Test = require('./containers/TestContainer').default
      const reducer = require('./modules/test').default
      injectReducer(store, { key: 'test', reducer })
      var patientId = nextState.params.id
      store.dispatch(getPatientDetail(patientId))
      cb(null, Test)
    }, 'test')
  }
})



// WEBPACK FOOTER //
// ./src/routes/Test/index.js